var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preview-block" },
    [
      _c(
        "multipane",
        { attrs: { layout: "horizontal" } },
        [
          _c(
            "div",
            { staticClass: "question-preview" },
            [_c("QuestionComponent")],
            1
          ),
          _vm._v(" "),
          _c("multipane-resizer"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "explain-preview", style: { flexGrow: 1 } },
            [
              _c("ExplanationPreviewComponent", {
                attrs: { groupQuestions: _vm.groupQuestions },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }